<rt-box [variant]="rtBoxVariant()" padding-tb-small-xx>
  <div
    (click)="onClick($event)"
    class="header"
    layout
    layout-full-width
    layout-space-between
    layout-align-items-center
  >
    <div class="left-content" layout layout-align-items-center>
      <ng-content select="[leftSlot]"></ng-content>

      @if (!collapseDisabled) {
        <rt-icon
          [name]="isCollapsed() ? 'expand-more' : 'expand-less'"
          margin-left-small-xx
        ></rt-icon>
      }
    </div>
    <div class="right-content" layout layout-justify-flex-end margin-left-small-x>
      <ng-content select="[rightSlot]"></ng-content>
    </div>
  </div>

  @if (!isCollapsed()) {
    @if (hasHeaderDivider) {
      <div margin-lr>
        <rt-divider variant="line light solid" [hasNoMargin]="true"></rt-divider>
      </div>
    }

    <div layout layout-align-items-center>
      <ng-content select="[collapsible]"></ng-content>
    </div>
  }
</rt-box>
